// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"48":"1fcbeea548934d4e","227":"5f1e3e753e308a84","338":"3f7d9f835b729aee","561":"13f9dfc8fdd48ca5","785":"9451645d9105e379"}[chunkId] + ".css";
};